import { useEffect, useState } from 'react';
import Markdown from 'react-markdown';
import { ArrowLeft } from 'lucide-react';
import { LoadingSpinner } from '../components/ui/LoadingSpinner';

export function TermsPage() {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch('/terms-and-conditions.md')
      .then((res) => {
        if (!res.ok) throw new Error('Failed to load');
        return res.text();
      })
      .then(setContent)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Top bar */}
      <div className="sticky top-0 z-10 bg-white border-b border-stone-200 px-4 py-3">
        <div className="max-w-2xl mx-auto flex items-center gap-3">
          <button
            type="button"
            onClick={() => window.close()}
            className="h-9 w-9 rounded-lg flex items-center justify-center text-stone-500 hover:text-stone-900 hover:bg-stone-100 transition-colors"
            aria-label="Close"
          >
            <ArrowLeft size={18} />
          </button>
          <h1 className="text-base font-semibold text-stone-900">Terms and Conditions</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-2xl mx-auto px-4 py-8">
        {loading && (
          <div className="flex items-center justify-center py-16">
            <LoadingSpinner size="lg" />
          </div>
        )}

        {error && (
          <div className="text-center py-16">
            <p className="text-stone-500 text-sm">Unable to load Terms and Conditions.</p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="mt-4 text-sm text-violet-600 hover:text-violet-700 font-medium"
            >
              Try again
            </button>
          </div>
        )}

        {!loading && !error && (
          <article className="prose prose-stone prose-sm max-w-none
            prose-headings:text-stone-900 prose-headings:font-semibold
            prose-h1:text-2xl prose-h1:mb-6
            prose-h2:text-lg prose-h2:mt-8 prose-h2:mb-3
            prose-h3:text-base prose-h3:mt-6 prose-h3:mb-2
            prose-p:text-stone-600 prose-p:leading-relaxed
            prose-li:text-stone-600
            prose-a:text-violet-600 prose-a:no-underline hover:prose-a:underline
            prose-strong:text-stone-900
          ">
            <Markdown>{content}</Markdown>
          </article>
        )}
      </div>
    </div>
  );
}
